<template><div><h1>VUX V2.1.0Rc.48 发布日志</h1>
<h2><a href="/zh-CN/components/x-input.html">XInput</a></h2>
<ul><li>[feature] 支持`debounce` #715 @YYmmlin</li>
</ul>
<h2><a href="/zh-CN/components/debounce.html">Debounce</a></h2>
<ul><li>[feature] 添加`debounce`工具</li>
</ul>
<h2><a href="/zh-CN/components/throttle.html">Throttle</a></h2>
<ul><li>[feature] 添加`throttle`工具</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.1.0Rc.48 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.1.0-rc.48-199.vue?3c6e56a4